import { useCallback, useEffect, useState } from "react";
import Titulo from "../../../atoms/titles/Titulo";
import { handleData } from "../../../../utils/HandleUtils";
import { getBusquedaModUsuarioPasswd } from "../../../services/UsuariosWebService";
import DataTablePaginacionExterna from "../../../atoms/datatable/DataTablePaginacionExterna";
import { SpinnerCircle } from "../../../atoms/spinner/Spinner";
import ConstantesTabla from "../../../../utils/ConstantesTabla";
import { Iconos } from "../../../../utils/Iconos";
import ModalCambioPasswdUsuariosWeb from "../../../molecules/modals/modalsUsuariosWeb/ModalCambioPasswdUsuariosWeb";
import ModalCambioUsuarioUsuariosWeb from "../../../molecules/modals/modalsUsuariosWeb/ModalCambioUsuarioUsuariosWeb";




const ModNombrePasswd = (object) => {
    const [loading, setLoading] = useState(false)
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(5);
    const [data, setData] = useState();
    const [totalPages, setTotalPages] = useState(0);
    const [showPass, setShowPass] = useState(false);
    const [showUser, setShowUser] = useState(false);
    const [dniMod, setDniMod] = useState();
    const [usuarioMod, setUsuarioMod] = useState();
    const [busquedaRealizada, setBusquedaRealizada] = useState(false);


    const handleShowUsuario = (dni, usuario) => {
        setShowUser(!showUser);
        setDniMod(dni)
        setUsuarioMod(usuario)
    };

    const handleCloseUsuario = (e) => {
        setShowUser(false);
    };

    const handleShowPasswd = () => {
        setShowPass(!showPass);
    };

    const handleClosePasswd = (e) => {
        setShowPass(false);
    };

    const [formBus, setFormBus] = useState({
        dni: null,
        nombre: null,
        apellido1: null,
        apellido2: null
    })

    const acciones = [{
        name: "Modificar Usuario",
        selector: (row) => (<>
            <div className="cursorPointer" onClick={() => handleShowUsuario(row[4], row[5])}>
                {Iconos.iconoPen}
            </div>
        </>)
        ,
        wrap: true,
        grow: .8, // Set grow to 0 to prevent the column from taking up extra space
        maxWidth: "200px", // Set a fixed width for the column

        style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        }
    },
    {
        name: "Modificar Contraseña",
        selector: (row) => (<>
            <div className="cursorPointer" onClick={() => handleShowPasswd()}>
                {Iconos.iconoPen}
            </div>
        </>)
        ,
        wrap: true,
        grow: 1, // Set grow to 0 to prevent the column from taking up extra space
        // maxWidth: "100px", // Set a fixed width for the column

        style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        }
    }]


    // const acciones = {
    //     name: "Acciones",
    //     selector: (row) =>(<><div className="cursorPointer">
    //         {Iconos.iconoPen}
    //     </div>
    //     </>)
    //       ,
    //     wrap: true,
    //     grow: 0, // Set grow to 0 to prevent the column from taking up extra space
    //     maxWidth: "100px", // Set a fixed width for the column

    //     style: {
    //         display: "flex",
    //         justifyContent: "center",
    //         alignItems: "center", 
    //     }
    //   }

    // const handleEnvioBusqueda = (valores, currentPage, pageSize) => {
    //     
    //     
    //     
    //     setLoading(true)
    //     setBusquedaRealizada(false)
    //     getBusquedaModUsuarioPasswd(valores, currentPage, pageSize).then((data) => {
    //         
    //         setData(data)
    //         setTotalPages(data.totalPages);
    //         setBusquedaRealizada(true)
    //         setLoading(false)
    //     })
    // }

    const handleEnvioBusqueda = useCallback((valores, currentPage, pageSize) => {
        setLoading(true)
        // setBusquedaRealizada(false)
        getBusquedaModUsuarioPasswd(valores, currentPage, pageSize).then((data) => {
            
            setData(data)
            setTotalPages(data.totalPages);
            // setBusquedaRealizada(true)
            setLoading(false)
        })
    }, []);

    // const handleActualizacionPaginacion = () => {
    //     setBusquedaRealizada(true);
    //     setSearchQuery(formBus); // update search query state
    // };


    // useEffect(() => {
    //     if (busquedaRealizada) {
    //         setLoading(true)

    //         getBusquedaModUsuarioPasswd(formBus, currentPage, pageSize).then((data) => {
    //             
    //             setData(data)
    //             setTotalPages(data.totalPages);

    //             setLoading(false)
    //         })
    //     }


    //   }, [busquedaRealizada,formBus]);

    useEffect(() => {
        
        if (currentPage >= 0 && pageSize >= 0) {
            getBusquedaModUsuarioPasswd(formBus, currentPage, pageSize).then((data) => {
                
                setData(data)
                setTotalPages(data.totalPages);

                setLoading(false)
            })
        }

    }, [currentPage, pageSize,formBus])



    return (<>
        <div className="container">
            <div className="formNuevaAltaUsuario">
                <div className="mt-2 text-center row">
                    <Titulo
                        titulo="Introduzca los parámetros de búsqueda para seleccionar el usuario cuyo nombre de usuario o clave desea modificar"
                        tipo="tituloPagina3"
                    />
                </div>
                <div className="formBusqueda mt-3 mb-5">
                    <div className="row d-flex justify-content-center mb-2">
                        <div className="col-5 row align-items-center">
                            <label htmlFor="dniAcceso" className="col-4">DNI:</label>
                            <div className="col-8">
                                <input type="text" id="dniAcceso" className="form-control"
                                    onChange={(e) => handleData(e.target.value, "dni", setFormBus)}
                                />
                            </div>
                        </div>
                        <div className="col-5 row align-items-center">
                            <label htmlFor="nombreAcceso" className="col-4">Nombre:</label>
                            <div className="col-8">
                                <input type="text" id="nombreAcceso" className="form-control"
                                    // onChange={(e) => handleInput(e,"nombre",setFormBus)}
                                    onChange={(e) => handleData(e.target.value, "nombre", setFormBus)}
                                />
                            </div>
                        </div>

                    </div>
                    <div className="row d-flex justify-content-center">
                        <div className="col-5 row align-items-center">
                            <label htmlFor="ape1Acceso" className="col-4">Apellido 1:</label>
                            <div className="col-8">
                                <input type="text" id="ape1Acceso" className="form-control"
                                    // onChange={(e) => handleInput(e,"apellido1",setFormBus)}
                                    onChange={(e) => handleData(e.target.value, "apellido1", setFormBus)}

                                />
                            </div>
                        </div>
                        <div className="col-5 row align-items-center">
                            <label htmlFor="ape2Acceso" className="col-4">Apellido 2:</label>
                            <div className="col-8">
                                <input type="text" id="ape2Acceso" className="form-control"
                                    // onChange={(e) => handleInput(e,"apellido2",setFormBus)}
                                    onChange={(e) => handleData(e.target.value, "apellido2", setFormBus)}

                                />
                            </div>
                        </div>
                    </div>
                    <div className="row mt-5 justify-content-between">
                        <div className="col-3 ">
                            <button
                                className={`btnRed rounded p-1`}
                                type="button"
                                onClick={() => object.setZona({ links: true })}
                            >
                                <i className="fa-solid fa-rotate-left"></i>{" "}
                                Volver
                            </button>
                        </div>
                        <div className="col-3 ">
                            <button
                                className={`btn rounded p-1`}
                                type="button"
                                onClick={() => handleEnvioBusqueda(formBus, currentPage, pageSize)}
                            >
                                Buscar
                            </button>
                        </div>
                    </div>
                </div>
                <div className="tablaUsuariosMod">
                    {loading && data !== undefined && data !== null ? (<><div><SpinnerCircle /></div></>) : (<>
                        {data !== undefined ? (<>
                            {data?.content?.length !== 0 ? (<>
                                <DataTablePaginacionExterna
                                    data={data}
                                    columnas={[
                                        ...ConstantesTabla.columnasModUsuariosWeb, ...acciones
                                    ]}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                    pageSize={pageSize}
                                    setPageSize={setPageSize}
                                    totalPages={totalPages}
                                />
                            </>) : (<>  <div className="row">
                                <span className="text-center col">No hay usuarios que respondan a esos parámetros de búsqueda</span>
                            </div></>)}
                        </>) : null}

                    </>)}

                </div>
            </div>
        </div>

        {showUser ? (
            <>
                <ModalCambioUsuarioUsuariosWeb
                    show={showUser}
                    handleClose={handleCloseUsuario}
                    titulo="Error al recuperar el PDF"
                    tipo="tituloBorrador rojo"
                    niep={dniMod}
                    usuario={usuarioMod}
                    currentPage={currentPage}
                    pageSize={pageSize}
                    setLoading={setLoading}
                    busquedaRealizada = {busquedaRealizada}
                    setBusquedaRealizada={setBusquedaRealizada}
                    setTotalPages={setTotalPages}
                    setListaUsuarios={setData}

                />
            </>
        ) : null}

        {showPass ? (
            <>
                <ModalCambioPasswdUsuariosWeb
                    show={showPass}
                    handleClose={handleClosePasswd}
                    titulo="Error al recuperar el PDF"
                    tipo="tituloBorrador rojo"
                    niep={dniMod}
                />
            </>
        ) : null}
    </>)
}

export default ModNombrePasswd;
